export default {
  lockedButton: {
    fontSize: '1.5rem',
    float: 'right',
    marginBottom: '2rem'
  }
}



// WEBPACK FOOTER //
// ./src/components/Locked/style.js